import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2ftd4cl8ew3ml">
      {visible && <motion.div initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-navy/0 p-3 md:inset-x-auto md:bottom-6 md:right-6 md:p-0" data-id="element-34" data-mp="2fsbgtha7lonz">
          <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-coral px-7 py-4 font-display text-lg font-bold uppercase tracking-wide text-white shadow-[0_5px_0_#b2330f,0_14px_30px_rgba(15,37,87,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-sun" data-id="element-35" data-mp="2z1pf13dvdk5s">
            Get instant access — $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="2fdp2uu3qwzlp" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}